import { FC, MutableRefObject, ReactElement, useState } from 'react'
import { Box, CircularProgress, Grid } from '@mui/material'
import clsx from 'clsx'
import {
  FinanceBreakDownViews,
  GeneralError,
  GlobalCalculatorError,
  IWidgetConfiguration,
  useWidgetContext,
} from '@dxp-module/common'
import LoadingOverlayContext from '../../../react/LoaderOverlayContext'
import CalculatorErrorContext from '../../../../financeCalculatorForm/react/CalculatorErrorContext'
import widgetScreenStyles from '../widgetScreen.styles'

type GlobalLoaderWrapperProps = {
  widgetRef: MutableRefObject<undefined>
  children: (props: GlobalCalculatorError) => ReactElement
  configuration: IWidgetConfiguration
}

const GlobalCalculatorWrapper: FC<GlobalLoaderWrapperProps> = ({
  configuration,
  children,
  widgetRef,
}) => {
  const {
    container,
    breakdownLoadingOverlay,
    breakdownPaperContainer,
    paperContainer,
    globalLoader,
    reffineLoader,
    loadingOverlay,
    childrenWrapper,
    loaderContainer,
    reffineLoadingOverlay,
  } = widgetScreenStyles()
  const {
    configuration: { reffineIntegration },
  } = useWidgetContext()
  const [globalLoading, setGlobalLoading] = useState<boolean>(false)
  const [calculatorError, setCalculatorError] = useState<GeneralError | null>(
    null
  )
  const isBreakdown = configuration.viewMode === FinanceBreakDownViews.BREAKDOWN

  return (
    <CalculatorErrorContext.Provider
      value={{ calculatorErrorState: [calculatorError, setCalculatorError] }}
    >
      <LoadingOverlayContext.Provider
        value={{ globalLoading: [globalLoading, setGlobalLoading] }}
      >
        <Box className={container}>
          <Grid
            component={Box}
            className={clsx([
              paperContainer,
              {
                [breakdownPaperContainer]: isBreakdown,
                [loaderContainer]: globalLoading,
              },
            ])}
            ref={widgetRef}
          >
            {globalLoading && (
              <Box
                position="absolute"
                className={clsx([
                  globalLoader,
                  { [reffineLoader]: reffineIntegration },
                ])}
              >
                <CircularProgress />
              </Box>
            )}
            <Box className={childrenWrapper} position="relative">
              {globalLoading && (
                <Box
                  className={clsx([
                    loadingOverlay,
                    {
                      [breakdownLoadingOverlay]: isBreakdown,
                      [reffineLoadingOverlay]: reffineIntegration,
                    },
                  ])}
                />
              )}
              {children({ calculatorError })}
            </Box>
          </Grid>
        </Box>
      </LoadingOverlayContext.Provider>
    </CalculatorErrorContext.Provider>
  )
}

export default GlobalCalculatorWrapper
